<template>
<div>
  <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">转账</el-button>
  <el-dialog :visible="dialogVisible" title="发起转账" width="500px" @close="closeDialog">
    <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="转入账号:" prop="toUserId">
        <el-input v-model="detail.toUserId"></el-input>
      </el-form-item>
      <el-form-item label="转出账号:" prop="fromUserId">
        <el-input v-model="detail.fromUserId"></el-input>
      </el-form-item>
      <el-form-item label="币种：" prop="pairType">
        <el-select v-model="detail.pairType" placeholder="请选择">
          <el-option v-for="item in coinTypes" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="转账金额:" prop="fromUserId">
        <el-input-number v-model="detail.transferAmount" :controls="false" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import {
  mapActions,
  mapState
} from 'vuex';

export default {
  name: 'PledgeCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        day: {
          required: true,
          message: '请填写',
          trigger: 'blur'
        },
        annualrate: {
          required: true,
          message: '请填写',
          trigger: 'blur'
        }
      }
    };
  },
  computed: {
    ...mapState('transferInner', ['coinTypes'])
  },
  methods: {
    ...mapActions('transferInner', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.create(this.detail).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('refresh', {
              page: 1
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
